import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import PropTypes from 'prop-types';
import { path } from 'ramda';

import { post } from 'lib/communication';

import FeedbackDialog from 'components/FeedbackDialog';

const validEmail = email => {
  const emailRegexp = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;
  if (email && typeof email === 'string') {
    return email.match(emailRegexp);
  }
  return false;
};

class FeedbackContainer extends Component {
  state = {
    content: {},
    notFilled: [],
    error: null,
    sending: false,
  };

  handleInput = (field, input) => {
    this.setState({ content: { ...this.state.content, [field]: input } });
  };

  getInput = field => this.state.content[field] || '';

  handleCancel = () => {
    this.setState({ content: {}, notFilled: [], error: null });
    this.props.openDialog(false);
  };

  sendData = setRequestSent => {
    // In flight request exists, do not send another
    if (this.state.sending) return;
    const { content } = this.state;
    const { userSession, router } = this.props.feedbackMeta;
    const fields = ['email', 'type', 'subject', 'description'];

    if (fields.some(f => !path([f], content))) {
      this.setState({ notFilled: fields.filter(m => !path([m], content)) });
      return;
    }
    if (!validEmail(content.email)) {
      return;
    }

    this.setState({ content: {}, notFilled: [], error: null, sending: true });

    post('/cs/v1/servicedeskapi/request', {
      // These should be appended in back-end based on the environment.
      // serviceDeskId: 1=Demo service desk, 2=SQ Service Desk
      requestFieldValues: {
        summary: content.subject,
        description: [
          '*Meta*',
          'UID: ' + userSession.userid.slice(0, 8),
          'PID: ' + userSession.id.slice(0, 8),
          'Role: ' + userSession.role,
          'Route: ' + router.location.pathname,
          '\n',
          '*Feedback*',
          String(this.state.content.description),
        ].join('\n'),
      },
      raiseOnBehalfOf: content.email,
      // This is mapped in backend to match right service desk ids
      // Demo: map to id '1'
      // SQ: Map 'incident' => '14', 'improvement' => '16', 'other' => '12'
      requestTypeId: content.requestType,
    })
      .then(res => {
        // Not handling request errors here, as they are handled by the createFetcher util function already
        // We also do not do anything with the response, so no need to parse it.
        this.setState({ content: {}, notFilled: [], error: null, sending: false });
        this.props.openDialog(false);
      })
      .catch(err => {
        this.setState({ error: 'err' });
        console.log('Error', err, 'Create request fetch');
      })
      .finally(() => {
        this.setState({ sending: false });
      });
  };

  render() {
    const {
      intl: { formatMessage },
    } = this.props;
    const { router } = this.props.feedbackMeta;
    const makeInputHandler = field => input => this.handleInput(field, input);
    return (
      <div>
        <FeedbackDialog
          visible={this.props.visible}
          onInput={makeInputHandler}
          onSend={this.sendData}
          onCancel={this.handleCancel}
          getInput={this.getInput}
          formatMessage={formatMessage}
          route={router.location.pathname}
          missingFields={this.state.notFilled}
          validEmail={validEmail}
          error={this.state.error}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  feedbackMeta: {
    userSession: state.session,
    router: state.router,
  },
});

FeedbackContainer = connect(mapStateToProps, null)(FeedbackContainer);

FeedbackContainer.propTypes = {
  intl: intlShape,
  userSession: PropTypes.string,
  router: PropTypes.object,
  feedbackMeta: PropTypes.object,
  visible: PropTypes.bool,
  openDialog: PropTypes.func,
};

export default injectIntl(FeedbackContainer);
